export default __webpack_public_path__ + "static/media/piscina.3fee28e9.png";